import useWidth from '@components/Hooks/useWidth';
import { OverflowTabs } from './components/OverflowTabs';
import { ScrollableTabs } from './components/ScrollableTabs';
import { TabItem } from './tabs.types';

interface TabsProps {
  items: TabItem[];
  selectedId: string;
  onSelect: (id: string) => void;
}

function Tabs({ items, selectedId, onSelect }: TabsProps) {
  const { mobileWidth } = useWidth();

  if (mobileWidth) {
    return <ScrollableTabs items={items} selectedId={selectedId} onSelect={onSelect} />;
  }

  return <OverflowTabs items={items} selectedId={selectedId} onSelect={onSelect} />;
}

export type { TabsProps };
export default Tabs;
